import { useEffect, useState } from 'react';

// Shared layout breakpoints for the app shell.
//   width <= MOBILE_BREAKPOINT   -> desktop sidebar hidden, MobHeader hamburger + drawer
//   width <  COMPACT_BREAKPOINT  -> sidebar forced to the 60px icon rail
// Keep MOBILE_BREAKPOINT in sync with the 991px media queries in
// SidebarStyle.js and MobHeaderStyle.js.
export const MOBILE_BREAKPOINT = 991;
export const COMPACT_BREAKPOINT = 1200;

const getWidth = () => (typeof window === 'undefined' ? 0 : window.innerWidth);

// Tracks window.innerWidth reactively. rAF-throttled so drag-resizing the
// window doesn't fire a render per resize event.
const useWindowWidth = () => {
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    let frame = null;
    const onResize = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        setWidth(getWidth());
      });
    };
    window.addEventListener('resize', onResize);
    // Catch any width change that happened between first render and mount.
    onResize();
    return () => {
      if (frame !== null) window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return width;
};

export default useWindowWidth;
